import {useEffect,useState} from 'preact/hooks';
import {getSummoning,subscribeSummoning,commandCompanion} from '@/summoning';
import {useClient} from '@/ui/context';
import {UI_ITEM_BG,UI_PANEL_BORDER} from '@/ui/consts';
import {CompanionButton} from '@/ui/in-game/hud/companion-button';
export function SummoningPanel(){
 const c=useClient();const [view,setView]=useState(()=>getSummoning(c));
 useEffect(()=>{const off=subscribeSummoning(c,()=>setView(getSummoning(c)));commandCompanion(c,'summon_status');
  const refresh=()=>commandCompanion(c,'summon_status');c.inventoryController.subscribeEquipmentChanged(refresh);
  return ()=>{off();c.inventoryController.unsubscribeEquipmentChanged(refresh);};},[c]);
 if(!view)return null;
 const active=view.summons.find(s=>s.owner===c.playerId),captured=view.books.find(b=>b.item_id===view.equipped_book);
 if(!view.equipped_book&&!active)return null;
 const name=captured?c.getEnfRecordById(captured.npc_id)?.name:'Empty Book';
 const book=view.book_instances.find(b=>b.equipped&&b.item_id===view.equipped_book);
 return <section class={`m-2 rounded border ${UI_PANEL_BORDER} ${UI_ITEM_BG} p-3 text-sm`} data-summoning-panel>
  <strong>{name} · Companion</strong>
  {book&&<p class='mt-1 text-xs'>Book level {book.level} · {book.next_xp===null?'Maximum level':`${book.xp-book.level_xp} / ${book.next_xp-book.level_xp} XP`}</p>}
  {view.equipped_book===view.empty_book?<p class='mt-1 text-xs'>Defeat monsters with your Empty Book equipped to attempt capture. Stronger monsters are harder to capture. Bosses cannot be captured.</p>:<>
   <p class='mt-1 text-xs'>WIS strengthens book attacks, healing and companions. Choose an enemy or use Fight nearby to protect the area around you.</p>
   {active&&<p class='mt-2'>Health {active.hp}% · {Math.ceil(active.remaining_ms/1000)}s remaining</p>}
   <CompanionButton className='mt-2' />
   {active&&<button type='button' class='btn btn-sm mt-2 ml-2' onClick={()=>commandCompanion(c,'summon_dismiss')}>Dismiss</button>}
   {active&&<p class='mt-1 text-xs'>Enable PK and select a player to command an attack. You are responsible for your companion's kills.</p>}
   <p class='mt-1 text-xs'>Summon with the button or F. If your companion falls, wait 40 seconds. Face it and press Ctrl with a healing spell equipped to your book to restore its health.</p>
   {!view.learned&&<p class='mt-1 text-xs'>Learn Summon Companion from the Aeven Skillmaster.</p>}
  </>}
  {view.message&&<p class='mt-2 text-xs' role='status'>{view.message}</p>}
 </section>;
}
